export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_AUTHENTICATED_USER = 'Set authenticated user 👨‍💻';
export const SET_INTERVAL = 'Set interval 👨‍💻';
export const SET_SESSION_ACTIVITY = 'Set session activity state 👨‍💻';
